<button id="close" mat-flat-button disableRipple>
  <i class="material-icons" [mat-dialog-close]="true">close</i>
</button>
<img src="assets/icons/exclamation.svg" alt="warning icon" />
<mat-dialog-content>
  <b>WARNING!</b>
  <p>
    {{ data.message }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button id="cancel" mat-flat-button [mat-dialog-close]="true">Cancel</button>
  <button
    (click)="confirm()"
    id="save"
    mat-flat-button
    [mat-dialog-close]="true"
  >
    {{ data.confirm }}
  </button>
</mat-dialog-actions>
